import React, { useEffect, useState } from "react";
import "./adminKPIDash.css";
import { supabase } from "../../supabase_client.jsx";

export default function AdminKPIDash({ onViewSelect }) {
  const [kpis, setKpis] = useState({
    totalUsers: 0,
    newUsers: 0,
    totalBusinesses: 0,
    newBusinesses: 0,
    totalEvents: 0,
    newEvents: 0,
    reportedUsers: 0,
    reportedEvents: 0,
    totalRSVPs: 0,
  });

  const [animated, setAnimated] = useState(kpis);

  useEffect(() => {
    const fetchKPIs = async () => {
      const oneWeekAgo = new Date();
      oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);

      const { count: totalUsers } = await supabase
        .from("users")
        .select("*", { count: "exact", head: true })
        .eq("type", "User");

      const { count: newUsers } = await supabase
        .from("users")
        .select("*", { count: "exact", head: true })
        .eq("type", "User")
        .gte("timestamp", oneWeekAgo.toISOString());

      const { count: totalRSVPs } = await supabase
        .from("marked_yes_events")
        .select("*", { count: "exact", head: true });

      const { count: totalBusinesses } = await supabase
        .from("users")
        .select("*", { count: "exact", head: true })
        .eq("type", "Business");

      const { count: newBusinesses } = await supabase
        .from("users")
        .select("*", { count: "exact", head: true })
        .eq("type", "Business")
        .gte("timestamp", oneWeekAgo.toISOString());

      const { count: totalEvents } = await supabase
        .from("events")
        .select("*", { count: "exact", head: true });

      const { count: newEvents } = await supabase
        .from("events")
        .select("*", { count: "exact", head: true })
        .gte("date", oneWeekAgo.toISOString());

      const { count: reportedUsers } = await supabase
        .from("users")
        .select("*", { count: "exact", head: true })
        .eq("type", "User")
        .eq("is_reported", true);

      const { count: reportedEvents } = await supabase
        .from("events")
        .select("*", { count: "exact", head: true })
        .eq("is_reported", true);

      setKpis({
        totalUsers: totalUsers || 0,
        newUsers: newUsers || 0,
        totalBusinesses: totalBusinesses || 0,
        newBusinesses: newBusinesses || 0,
        totalEvents: totalEvents || 0,
        newEvents: newEvents || 0,
        reportedUsers: reportedUsers || 0,
        reportedEvents: reportedEvents || 0,
        totalRSVPs: totalRSVPs || 0
      });
    };

    fetchKPIs();
  }, []);

  useEffect(() => {
    const duration = 800;
    const steps = 30;
    const interval = duration / steps;

    Object.keys(kpis).forEach((key) => {
      let start = 0;
      const end = kpis[key];
      const increment = end / steps;

      const timer = setInterval(() => {
        start += increment;
        if (start >= end) {
          start = end;
          clearInterval(timer);
        }

        setAnimated((prev) => ({
          ...prev,
          [key]: Math.floor(start),
        }));
      }, interval);
    });
  }, [kpis]);

  return (
    <div className="home-container">
      <div className="home-card">

        {/* NAV */}
        <div className="calendar-top-nav">
          <div className="nav-left">
            <button className="nav-tab" onClick={() => onViewSelect("admin")}>
              General
            </button>
            <button className="nav-tab" onClick={() => onViewSelect("adminCalendar")}>
              Event Calendar
            </button>
            <button className="nav-tab active">
              KPI Dashboard
            </button>
            <button className="nav-tab" onClick={() => onViewSelect("adminEventManagement")}>
              Event Management
            </button>
            <button className="nav-tab" onClick={() => onViewSelect("user-management")}>
              User Management
            </button>
            <button className="nav-tab" onClick={() => onViewSelect("business-management")}>
              Business Management
            </button>
            <button className="bpActionBtn secondary" onClick={() => {
            sessionStorage.removeItem("currentUser");
            sessionStorage.removeItem("currentView");
            onViewSelect("loginSignup");
          }}>
            Log Out
          </button>
          </div>
        </div>

        <div className="dashboard-container">
          <div className="dash-header">
            <h1>Platform Dashboard</h1>
          </div>

          {/*User */}
          <section>
            <h2 className="section-title">Users</h2>
            <div className="kpi-grid">
              <div className="kpi-card">
                <h3>{animated.totalUsers}</h3>
                <p>Total Users</p>
              </div>
              <div className="kpi-card">
                <h3>{animated.newUsers}</h3>
                <p>New Users</p>
              </div>
              <div className="kpi-card warning">
                <h3>{animated.reportedUsers}</h3>
                <p>Reported Users</p>
              </div>
              <div className="kpi-card">
                <h3>{animated.totalRSVPs}</h3>
                <p>Total Event Signups</p>
              </div>
            </div>
          </section>

          {/* Business */}
          <section>
            <h2 className="section-title">Businesses</h2>
            <div className="kpi-grid">
              <div className="kpi-card">
                <h3>{animated.totalBusinesses}</h3>
                <p>Total Businesses</p>
              </div>
              <div className="kpi-card">
                <h3>{animated.newBusinesses}</h3>
                <p>New Businesses</p>
              </div>
            </div>
          </section>

          {/* Event */}
          <section>
            <h2 className="section-title">Events</h2>
            <div className="kpi-grid">
              <div className="kpi-card">
                <h3>{animated.totalEvents}</h3>
                <p>Total Events</p>
              </div>
              <div className="kpi-card">
                <h3>{animated.newEvents}</h3>
                <p>New Events</p>
              </div>
              <div className="kpi-card warning">
                <h3>{animated.reportedEvents}</h3>
                <p>Reported Events</p>
              </div>
            </div>
          </section>

        </div>
      </div>
    </div>
  );
}